// extracted by css-extract-rspack-plugin
export default {"Details":"Tips-module__Details__kthgb","OpenLastItem":"Tips-module__OpenLastItem__yOIzD"};